import React from 'react'
import { Grid } from 'react-styled-flexboxgrid'
import { ThemeProvider } from 'styled-components'

import FlexBoxGridTheme from './tableTheme'

import InputRowNoPassword from "./InputRowNoPassword"

const InputRow = ({ notched }) => {
  return (
    <ThemeProvider theme={FlexBoxGridTheme}>
      <Grid fluid>
        <InputRowNoPassword notched={notched} />
      </Grid>
    </ThemeProvider>
  )
}

export default InputRow
